import React, {useEffect} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {
  useContainerWidth,
  useIsFirstCard,
  useIsLastCard,
  useNotifyUpdatedCards,
} from '../../common-components/default-carousel'
import {TestimonialAuthor, TestimonialCardContent} from './styles'

const getNumberOfCardWidthByContainerWidth = (containerWidth: number): number => {
  let numberOfCards = 1
  if (containerWidth >= 1300) {
    numberOfCards = 3
  }
  if (containerWidth >= 1000) {
    numberOfCards = 2
  }

  return numberOfCards
}

const propTypes = {
  testimonial: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  portrait: PropTypes.string,
}

const defaultProps = {
  portrait: undefined as null | undefined,
}

export type TestimonialCardProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const TestimonialCard = React.forwardRef<HTMLDivElement, TestimonialCardProps>(
  ({testimonial, position, portrait, name}, ref) => {
    const containerWidth = useContainerWidth()
    const desiredNumberOfCards = getNumberOfCardWidthByContainerWidth(containerWidth)
    const isFirstCard = useIsFirstCard()
    const isLastCard = useIsLastCard()
    const notifyUpdatedCards = useNotifyUpdatedCards()

    useEffect(() => {
      // since our TestimonialCardContent width is depending on the containerWidth we need
      // to trigger a notification
      notifyUpdatedCards()
    }, [containerWidth, notifyUpdatedCards])

    return (
      <TestimonialCardContent
        ref={ref}
        isActive={isFirstCard}
        containerWidth={containerWidth}
        numberOfCards={desiredNumberOfCards}
        isLastCard={isLastCard}
        isFirstCard={isFirstCard}
      >
        <p>{testimonial}</p>
        <TestimonialAuthor>
          {portrait && <img src={portrait || ''} alt={name} />}
          <span>
            {name}
            <br />
            {position}
          </span>
        </TestimonialAuthor>
      </TestimonialCardContent>
    )
  }
)

TestimonialCard.propTypes = propTypes

TestimonialCard.defaultProps = defaultProps

export default React.memo(TestimonialCard)
